import { Card, Step } from 'components';
import { useAnalytics } from 'contexts/Analytics/Analytics';
import { useContent } from 'contexts/Content/Content';
import Export from './Export';
import RsbCta from './RsbCta';

export default function Finish() {

    const analytics = useAnalytics();
    const content = useContent();

    const onCoachCta = () => {
        void analytics.trackActionEvent('action_tool_completed', {
            resource_id: 'coach_cta',
            resource_type: 'tool',
            source: 'finish_cards',
        });
    };
    const onLearnCta = () => {
        void analytics.trackActionEvent('action_tool_completed', {
            resource_id: 'learn_cta',
            resource_type: 'tool',
            source: 'finish_cards',
        });
    };

    return (
        <Step className="pdf-hide" description="Export your data, learn more, and get help." ordinal={3} title="Export & Next Steps">
            <div className="row">
                <div className="col-12 mb-5 pe-lg-4 col-lg-4">
                    <Export />
                </div>
                <div className="col-12 mb-5 col-lg-8">
                    {(!content.finish.card1 && !content.finish.card2) ? (
                        <RsbCta />
                    ) : (
                        <div className="row ms-lg-3 ps-lg-3 ms-xl-5 ps-xl-5">
                            {content.finish.card1 && (
                                <div className="col-12 pb-4 col-md-6 pb-md-0 pe-md-4">
                                    <Card
                                        image={content.finish.card1.image}
                                        imageAlt={content.finish.card1.imageAlt}
                                        subtitle={content.finish.card1.subtitle}
                                        title={content.finish.card1.title}
                                        url={content.finish.card1.url}
                                        onClick={onCoachCta}
                                    >
                                        {content.finish.card1.body}
                                    </Card>
                                </div>
                            )}
                            {content.finish.card2 && (
                                <div className="col-12 col-md-6 ps-md-4">
                                    <Card
                                        image={content.finish.card2.image}
                                        imageAlt={content.finish.card2.imageAlt}
                                        subtitle={content.finish.card2.subtitle}
                                        title={content.finish.card2.title}
                                        url={content.finish.card2.url}
                                        onClick={onLearnCta}
                                    >
                                        {content.finish.card2.body}
                                    </Card>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </Step>
    );
}
